import { useEffect, useState } from 'react';
import { getPostponedtrips, fetchDest, fetchleadsbynumber2, fetchCustomerbyDate, searchallTripsbyDate, searchLeadsbyDate, searchconvTripsbyStartDate, fetchTripsbyNumber, fetchcustbydob, url as serverurl, searchboTripsbyDate, fetchmarketingcustlist, fetchmarketingcustlist2, fetchCustomerbyNumber, fetchQuotebyId, searchconvTripsbyDate, fetchEmployees, ggwacampaign, searchDABTripsbyDate} from "../api/customerapi";
import { io } from "socket.io-client";
const socket = io(serverurl);
socket.on("connect", () => {
   console.log("Connected to socket:", socket.id);
 });
export default socket;